import React, { useEffect, useState, useRef } from 'react'
import {
    Select,
    MenuItem,
    TextField,
    FormControl,
    InputLabel,
    FormHelperText,
    Tooltip,
    IconButton,
} from '@material-ui/core'
import moment from 'moment'
import CustomDialog from '../../organisms/Dialog/index'

const BirthDateThreeInput = (props) => {
    const { formik, name, label, helperText, error, t } = props
    const value = formik.values[name] || ''
    const lastValueRef = useRef(value)
    const [toggleDialog, setToggleDialog] = useState(false)

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    // Parse value into parts robustly
    const parseValue = (val) => {
        if (!val) return { day: '', month: '', year: '' }

        // Try standard format first
        const formats = ['DD/MM/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY', 'MM/DD/YYYY', moment.ISO_8601]
        let mDate = moment(val, formats)

        if (mDate.isValid()) {
            return {
                day: mDate.date().toString().padStart(2, '0'),
                month: mDate.month(),
                year: mDate.year().toString(),
            }
        }

        // Fallback: manual split if it looks like DD/MM/YYYY but is invalid (partial)
        const parts = val.split('/')
        if (parts.length === 3) {
            return {
                day: parts[0],
                month: parts[1] ? parseInt(parts[1], 10) - 1 : '',
                year: parts[2],
            }
        }

        return { day: '', month: '', year: '' }
    }

    const [dateState, setDateState] = useState(() => parseValue(value))

    // Sync local state to Formik
    useEffect(() => {
        const { day, month, year } = dateState
        if (day || month !== '' || year) {
            const formattedMonth =
                month !== '' ? (parseInt(month, 10) + 1).toString().padStart(2, '0') : ''
            const formattedDay = day ? day.toString().padStart(2, '0') : ''
            const newValue = `${formattedDay}/${formattedMonth}/${year}`

            if (newValue !== value) {
                lastValueRef.current = newValue
                formik.setFieldValue(name, newValue)
            }
        }
    }, [dateState])

    // Sync Formik to local state ONLY if it changed externally
    useEffect(() => {
        if (value !== lastValueRef.current) {
            const updated = parseValue(value)
            setDateState(updated)
            lastValueRef.current = value
        }
    }, [value])

    const handleMonthChange = (e) => {
        setDateState((prev) => ({ ...prev, month: e.target.value }))
    }

    const handleDayChange = (e) => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 2)
        setDateState((prev) => ({ ...prev, day: val }))
    }

    const handleYearChange = (e) => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 4)
        setDateState((prev) => ({ ...prev, year: val }))
    }

    const months = moment.months()

    return (
        <div
            className={`customInput ${error ? 'error-input' : ''}`}
            style={{ ...props.inputStyle, textAlign: 'left' }}
        >
            <label htmlFor={props.id || name} style={{ textAlign: 'left', display: 'block' }}>
                {label}
                {props?.lableInfo ? (
                    <Tooltip title={props?.tooltiptitle}>
                        <IconButton>
                            <span
                                className="material-icons"
                                onClick={() => {
                                    if (props?.contents) {
                                        setToggleDialog(true)
                                    }
                                }}
                            >
                                info
                            </span>
                        </IconButton>
                    </Tooltip>
                ) : null}
            </label>

            <div className="d-flex align-items-start" style={{ gap: '10px', marginTop: '8px' }}>
                <TextField
                    select
                    label={!props.upperLabel ? t('Month') : undefined}
                    variant="outlined"
                    value={dateState.month}
                    onChange={handleMonthChange}
                    error={error}
                    style={{ flex: 2 }}
                    InputLabelProps={{
                        shrink: dateState.month !== '' || props.upperLabel === false,
                    }}
                >
                    {months.map((month, index) => (
                        <MenuItem key={month} value={index}>
                            {t(month)}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    label={!props.upperLabel ? t('Day') : undefined}
                    variant="outlined"
                    value={dateState.day}
                    onChange={handleDayChange}
                    error={error}
                    style={{ flex: 1 }}
                    placeholder="DD"
                    InputLabelProps={{ shrink: dateState.day !== '' || props.upperLabel === false }}
                />

                <TextField
                    label={!props.upperLabel ? t('Year') : undefined}
                    variant="outlined"
                    value={dateState.year}
                    onChange={handleYearChange}
                    error={error}
                    style={{ flex: 1.5 }}
                    placeholder="YYYY"
                    InputLabelProps={{
                        shrink: dateState.year !== '' || props.upperLabel === false,
                    }}
                />
            </div>
            {error && (
                <FormHelperText error style={{ marginLeft: '14px', marginRight: '14px' }}>
                    {helperText || 'Required!'}
                </FormHelperText>
            )}

            <CustomDialog
                title={
                    <div className="bidConfirmTitle">
                        {props?.tooltiptitle}
                        <div className="ssmHead d-flex justify-content-center">
                            <button
                                type="button"
                                className="close"
                                id="cancel"
                                onClick={() => setToggleDialog(false)}
                            >
                                <span className="material-icons">clear</span>
                            </button>
                        </div>
                    </div>
                }
                open={toggleDialog}
                function={changeDialogStatus}
                className="bidConfirmationCstm"
            >
                <div className="">
                    {props?.contents
                        ? props?.contents
                              .replace(/\$enter/g, '\n')
                              .split('\n')
                              .map((line, index) => <p key={index}>{line}</p>)
                        : null}
                </div>
            </CustomDialog>
        </div>
    )
}

export default BirthDateThreeInput
